import { render, staticRenderFns } from "./ServiceLevelAndPricing.vue?vue&type=template&id=2d20b2bd"
import script from "./ServiceLevelAndPricing.vue?vue&type=script&lang=ts"
export * from "./ServiceLevelAndPricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports